
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-initiatives",
      function () {
        return require("private-next-pages/our-initiatives.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-initiatives"])
      });
    }
  